import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Spin } from "antd";

const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const orderId = searchParams.get("orderId");
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderId) {
      // ถ้าไม่มี orderId ให้ redirect กลับหน้าหลัก
      navigate("/");
      return;
    }
    // ดึงข้อมูลออเดอร์จาก backend
    axios
      .get(`${process.env.REACT_APP_API}/order/${orderId}`)
      .then((res) => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [orderId, navigate]);

  if (loading) return <Spin />;

  if (!order) return <div>ไม่พบข้อมูลคำสั่งซื้อ</div>;

  return (
    <div className="container mt-5">
      <h2>สั่งซื้อสำเร็จ!</h2>
      <p>หมายเลขคำสั่งซื้อ: <b>{order.orderNumber}</b></p>
      <p>ขอบคุณที่ใช้บริการ 360 Healthy Shop</p>
      <hr />
      <h4>สรุปรายการสินค้า</h4>
      <ul>
        {order.products.map((item, idx) => (
          <li key={idx}>
            {item.product?.title} x {item.count}
          </li>
        ))}
      </ul>
      <p>ยอดรวม: {order.cartTotal} บาท</p>
    </div>
  );
};

export default OrderSuccess;